import * as Sentry from '@sentry/browser'
import type { AgentV2Reference } from '@/agent-v2/store/schemas'

/**
 * Split a reference payload into the references that belong to the given conversation
 * and the ones that do not (e.g. a late event from a previously open conversation).
 * Pure — callers pass `dropped` to reportDroppedAgentV2References.
 */
export function sanitizeAgentV2References(
  conversationId: string,
  references: AgentV2Reference[]
): { accepted: AgentV2Reference[]; dropped: AgentV2Reference[] } {
  const accepted: AgentV2Reference[] = []
  const dropped: AgentV2Reference[] = []
  for (const reference of references) {
    if (reference.conversation_id === conversationId) accepted.push(reference)
    else dropped.push(reference)
  }
  return { accepted, dropped }
}

/** The one place reference-ingest drops are reported: one event per bad payload, not per reference. */
export function reportDroppedAgentV2References(expectedConversationId: string, dropped: AgentV2Reference[]): void {
  if (dropped.length === 0) return
  const droppedSummaries = dropped.map((reference) => ({
    citationId: reference.citation_id,
    referenceId: reference.reference_id,
    conversationId: reference.conversation_id,
  }))
  console.error('Dropped Agent v2 references (conversation mismatch)', droppedSummaries)
  Sentry.captureMessage('Agent v2: dropped reference upsert (conversation mismatch)', {
    extra: { expectedConversationId, dropped: droppedSummaries },
  })
}
